const pagesVendorMarketplaceEn = {
  address: "Address",
  all: "All",
  amountToPay: "Amount to pay",
  approve: "Approve",
  approved: "Approved",
  canceled: "Canceled",
  cancellingOrder: "Cancelling order",
  cancelOrderDescription: "Please enter the reason for canceling the order.",
  customer: "Customer",
  delivery: "Delivery",
  description: "Description",
  details: "Details",
  estimatedDate: "Estimated date",
  handoverNotes: "Handover notes",
  lineNumber: "Line Number",
  oneshot: "Initial",
  payment: "Payment",
  period: "Period",
  place: "Place",
  quantity: "Quantity",
  salesOrders: "Sales Orders",
  recurring: "Recurring",
  requestedBy: "Requested by",
  requestSent: "Request received",
  shipping: "Shipping",
  subtotal: "Subtotal",
  tax: "Tax",
  taxPerUnit: "Tax per Unit",
  total: "Total",
  unitPrice: "Unit Price",
};

export default pagesVendorMarketplaceEn;
